import SeezSdk from './sdk.js'
import SeezarButton from './widget.js'

window.seezSdk = new SeezSdk()

window.seezSdk.addEventListener('targetSiteLoaded', () => {
  customElements.define('seez-sdk-seezar', SeezarButton)
  const components = document.querySelector('[data-inject-component]')?.getAttribute('data-inject-component')?.split(',') ?? []
  components.forEach(c => document.body.appendChild(document.createElement(c)))
})

document.dispatchEvent(new Event('seezSdkLoaded'))
